module.exports = __webpack_public_path__ + "static/media/login_aside_bg.daba50a7.svg";